module.exports = __webpack_public_path__ + "img/dropsmith-rieko-oshima-barclay.739c3272.png";